// dependencies
import React from "react";

import { IconDefinition, faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Typography from "../../../components/Text";

//css
import css from "./EmptySearchTableMessage.module.scss";

type EmptySearchTableMessageProps = {
	mainText?: string;
	icon?: IconDefinition;
};

const EmptySearchTableMessage: React.FC<EmptySearchTableMessageProps> = ({
	mainText = "No results found",
	icon = faSearch,
}: EmptySearchTableMessageProps) => {
	return (
		<div className={css.EmptySearchTableMessageWrapper}>
			<div className={css.icon}>
				<FontAwesomeIcon icon={icon} data-testid={icon.iconName} />
			</div>
			<Typography weight="semi-bold" size="paragraph-1">
				{mainText}
			</Typography>
		</div>
	);
};

export default EmptySearchTableMessage;
